import { useRef } from "react";
import _ from "lodash";

const useDebounce = (originalFunction, miliseconds) => {
  const originalFunctionRef = useRef(null);
  const debouncedFunction = useRef(null);

  originalFunctionRef.current = originalFunction;

  if (!debouncedFunction.current) {
    debouncedFunction.current = _.debounce((...args) => {
      originalFunctionRef.current(...args);
    }, miliseconds);
  }

  return debouncedFunction.current;
};

export default useDebounce;